import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Views} from '@ccp/config/views';
import {EnquirusService} from '@ccp/services/enquirus/enquirus.service';

export const EnquirusAccountCreationGuard: CanActivateFn = (route) => {
  const enquirusService = inject(EnquirusService);
  const router = inject(Router);

  if (!enquirusService.isAccountLinked$()) {
    return true;
  }

  const createRedirect = (path: string) =>
    router.createUrlTree([path], {
      queryParams: {...route.queryParams},
    });

  return createRedirect(Views.myEnquirusAccount.path);
};
